<div class="c-subheader sticky-top justify-content-between px-3 c-header-shadow">
    <ol class="breadcrumb border-0 m-0 px-0 px-md-3">
        <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
        <li class="breadcrumb-item"><a routerLink="/product">Produtos</a></li>
        <li class="breadcrumb-item active" aria-current="page">PDV</li>
    </ol>
    <!-- Breadcrumb Menu-->
    <div class="c-subheader-nav" >
        <div class="row btn-group" role="group">
            <div class="col-4">
                <button mat-button matTooltip="Limpar dados" style="background-color: red;color: #eeeff8;" (click)="limparFormulario()">
                    <i class="fa fa-eraser"></i> Limpar
                </button>
            </div>
            <div class="col-4">
                <button mat-raised-button style="background-color: green;color: #eeeff8;" matTooltip="Imprimir Venda" (click)="imprimir()">
                    <i class="fa fa-download"></i> Pedido
                </button>
            </div>
            <div class="col-4" >
                <button mat-raised-button color="primary" matTooltip="Salvar venda" (click)="openDialog()">
                    <i class="fa fa-floppy-o"></i> Concluir
                </button>
            </div>
        </div>
    </div>
</div>
<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <!-- ngFor for para percorrer o array de erros e se existir erros imprimir na tela -->
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">
            <mat-grid-list cols="5" rowHeight="100px">
                <mat-grid-tile [colspan]="5" [rowspan]="1">
                    <div class="font-30-center"> {{statusCaixa}} </div>
                </mat-grid-tile>
                <mat-grid-tile [colspan]="3" [rowspan]="4" class="full-width">
                    <!-- INICIO TABELA DE PRODUTOS -->
                    <div class="full-width">
                        <section class="tabel-container mat-elevation-z8" tabindex="0">
                            <table mat-table [dataSource]="productsSolds" class="full-width">
                                <!-- Coluna ID -->
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> Item </th>
                                    <td mat-cell *matCellDef="let productSold"> {{ productSold.item }} </td>
                                    <td mat-footer-cell *matFooterCellDef> Total </td>
                                </ng-container>

                                <!-- Coluna quantidade -->
                                <ng-container matColumnDef="quantity">
                                    <th mat-header-cell *matHeaderCellDef> Quantidade </th>
                                    <td mat-cell *matCellDef="let productSold"> {{ productSold.quantity }} </td>
                                    <td mat-footer-cell *matFooterCellDef></td>
                                </ng-container>

                                <!-- Coluna Nome -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                                    <td mat-cell *matCellDef="let productSold"> {{ productSold.product.name }} </td>
                                    <td mat-footer-cell *matFooterCellDef></td>
                                </ng-container>

                                <!-- Coluna preco -->
                                <ng-container matColumnDef="price">
                                    <th mat-header-cell *matHeaderCellDef>Preço</th>
                                    <td mat-cell *matCellDef="let productSold"> {{ productSold.price | currency:'BRL'}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="desconto">
                                    <th mat-header-cell *matHeaderCellDef>Desconto</th>
                                    <td mat-cell *matCellDef="let productSold"> {{ productSold.desconto |
                                        currency:'BRL'}}
                                    </td>
                                </ng-container>
                                <!-- Coluna preco total -->
                                <ng-container matColumnDef="priceTotal">
                                    <th mat-header-cell *matHeaderCellDef>Total</th>
                                    <td mat-cell *matCellDef="let productSold"> {{ productSold.priceTotal |
                                        currency:'BRL'}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="remover">
                                    <th mat-header-cell *matHeaderCellDef> Remover </th>
                                    <td mat-cell *matCellDef="let productSold">
                                        <button  (click)="removerItem(productSold.item)" mat-icon-button color="warn">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <!-- definir como vai ser as linhas e a ordem das colunas -->
                                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela; sticky: true"></tr>
                                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                            </table>
                        </section>
                        <!-- FIM TABELA DE PRODUTOS -->
                    </div>
                </mat-grid-tile>
                <!-- <mat-grid-tile [colspan]="2" [rowspan]="3">                    
                    <img mat-card-image src="/assets/images/logopdv.png" alt="Logo demo do sistema">
                </mat-grid-tile> -->
                <mat-grid-tile [colspan]="2" [rowspan]="4">
                    <mat-card style="height: 399px;">
                        <form [formGroup]="formAddItem" style="padding-top: 10px;">
                            <!-- ENTRADA DE DADOS CÓDIGO DE BARRAS --> 
                            <div class="row">
                                <div class="col-6"> 
                                    <mat-form-field appearance="fill" style="width: 100%;">
                                        <mat-label>Tipo Venda</mat-label>
                                        <mat-select id="typeSale" name="typeSale" [(value)]="typeSale" required>
                                            <mat-option [value]="typeSale" *ngFor="let typeSale of typesSale">{{typeSale}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>  
                                </div>
                                <div class="col-6"> 
                                    <mat-form-field appearance="fill" style="width: 100%;">
                                        <mat-label>Forma Pagamento</mat-label>
                                        <mat-select id="formaPagamento" name="formaPagamento" [(value)]="formaPagamento" required>
                                            <mat-option [value]="formaPagamento" *ngFor="let formaPagamento of formasPagamento">{{formaPagamento}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>  
                                </div>                                                          
                                <div class="col-3"> 
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Cód Cliente</mat-label>
                                        <input maxlength="13" formControlName="clientSolds" mask="separator.0" matInput
                                            placeholder="ex: 0000000000000" (change)="buscarClient()">
                                    </mat-form-field>
                                </div>
                                <div class="col-9"> 
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Cliente</mat-label>
                                        <input matInput value="{{nameClient}}" disabled>
                                    </mat-form-field>                                    
                                </div>
                                <div class="col-3"> 
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Cód do Produto</mat-label>
                                        <input maxlength="13" formControlName="id" mask="separator.0" matInput
                                            placeholder="ex: 0000000000000" (change)="buscarProduto()">
                                    </mat-form-field>
                                </div>
                                <div class="col-5"> 
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Produto</mat-label>
                                        <input matInput value="{{nameProduct}}" disabled>
                                    </mat-form-field>                                    
                                </div>
                                <div class="col-2"> 
                                    <mat-form-field class="full-width" appearance="fill">
                                        <mat-label>Qtd</mat-label>
                                        <input maxlength="3" formControlName="quantidade" mask="separator.0" matInput
                                            placeholder="ex: 1">
                                    </mat-form-field>
                                </div>
                                <div class="col-2"> 
                                    <mat-form-field class="full-width" appearance="fill">
                                        <mat-label>Desc</mat-label>
                                        <input formControlName="desconto" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" matInput>
                                    </mat-form-field>
                                </div>
                                <div class="col-12">
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Observação</mat-label>
                                        <textarea formControlName="observation" matInput placeholder="Observação"></textarea>
                                    </mat-form-field>  
                                </div>
                            </div>

                            <button [disabled]="!formAddItem.valid" class="full-width" mat-raised-button color="primary" (click)="adicionarItem()">
                                <mat-icon>add</mat-icon>
                                Incluir Produto
                            </button>
                        </form>
                    </mat-card>
                </mat-grid-tile>
                <iframe *ngIf="relatorioURL" [src]="relatorioURL" width="100%" height="500px"></iframe>
                <mat-grid-tile [colspan]="5" [rowspan]="1">
                    <mat-card class="full-width">
                        <div class="font-30-center">
                            Valor total a pagar: <b> {{getTotalCost() | currency:'BRL'}} </b>
                        </div>
                    </mat-card>
                </mat-grid-tile>
            </mat-grid-list>
            <!-- IMPRIMIR NA TELA
            <pre>{{ salevenda | json }}</pre> -->
        </div>
    </div>

</main>

 